<template>
  <div class="card" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Date</th>
          <th>Credit Note Number</th>
          <th>Bill Number & Date</th>
          <th>Party Name</th>
          <th class="text-right">Return Amount</th>
          <th class="text-right">Refund Amount</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in sales_return" :key="i">
          <td> {{ item.date }}</td>
          <td> {{ item.bill_number }}</td>
          <td> {{ item.sale_bill_number }}, {{ item.sale_bill_date }}</td>
          <td> {{ item.party_name }}</td>
          <td class="text-right"> {{ item.bill_amount }}</td>
          <td class="text-right"> {{ item.paid_amount }}</td>
          <td>
            <button class="btn btn-primary btn-sm"
                @click="goToEdit(item.id)"
                style="cursor: pointer"
                v-if="showEditButton"
            >
              <i class="fas fa-eye"></i>
            </button>
            <button class="btn btn-secondary btn-sm"
                    @click="goToPrint(item.id)"
                    style="cursor: pointer; margin-left: 10px"
            >
              <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!sales_return.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props = defineProps({
  sales_return: Array,
  route_name: {
    type: String,
    default: 'sales-return-edit'
  },
  showEditButton: {
    type: Boolean,
    default: true
  },
})

const route = useRoute()
const router = useRouter()
const goToEdit = (id) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
  }
  param['salesReturnId'] = id;
  router.push({
    name: props.route_name,
    params: param,
    query: route.query
  })
}
const goToPrint = (id) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
  }
  param['salesReturnId'] = id;
  router.push({
    name: 'sales-return-print',
    params: param,
    query: route.query
  })
}
</script>
